import type { FaireProductEntity } from "../../entity_types/product";

export const p_h279jqny62: FaireProductEntity = {
  token: "p_h279jqny62",
  type: "product",
  name: "Malibu Short Wavy Shimmer Tail",
  brandToken: "b_cxpu3vwkk5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b5b461d11f26931946dfb333d69537412bcb2c9ab10516d5a783a2ec56204ad1.jpeg",
  galleryImageUrls: [],
  priceDollars: 14,
  description:
    "\nSurf’s up, Dude! 🤙 We made our most popular color in a shorter size!\n\n16” sparkly inches of wavy unicorn hair on a strong hair elastic. Our Malibu Shimmer Tail Extension adds color, length and MAGIC to all your hairstyles. \n\n☀️ Wear it as a ponytail right over her natural hair\n\n🌴 Braid it into her hair for a dazzling braided style\n\n⛱️ Braid the extension in several sections for a fun festival look!\n\nMalibu Shimmer is ombré dyed in shades of pink, aqua and lavender and has lots of sparkly iridescent tinsel throughout. \n\nTo keep your Shimmer Tail looking great, give it a spritz of water and a quick comb through with a wide toothed comb before and after wearing. Store it flat in its plastic sleeve. \n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:46.772Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
